module.exports = __webpack_public_path__ + "packs/media/images/brand-6203e586eb2b1ee5f3e97f1f4af01fc6.png";